<template>
    <v-select v-model="selectedTypeResidence" :items="residenceTypes" :loading="isLoading" :disabled="disabled" item-value="key" :clear-icon="'far fa-times-circle'" :menu-props="{ bottom: true, offsetY: true }" @change="$emit('input', selectedTypeResidence)" :multiple="multiple" :label="label" :placeholder="placeholder" background-color="white" hide-details no-filter outlined clearable dense>
        <template v-slot:selection="data">
            <v-chip v-if="data.index === 0" color="accent" small label dark>
                {{ data.item.value }}
            </v-chip>

            <span v-if="data.index === 1" class="grey--text text-caption">
                (+{{ selectedTypeResidence.length - 1 }} autres)
            </span>
        </template>

        <template v-slot:item="{ item }">
            <v-list-item-content>
                <v-list-item-title>
                    <v-chip color="accent" label small dark>
                        {{ item.value }}
                    </v-chip>
                </v-list-item-title>
            </v-list-item-content>
        </template>
    </v-select>
</template>

<script>
import productsMixin from '../../mixins/products.js';

export default {
    name: 'TypeResidenceSelect',

    mixins: [productsMixin],

    props: {
        value: { required: true },
        label: { type: String },
        placeholder: { type: String },
        disabled: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false }
    },

    data: () => ({
        isLoading: false,
        residenceTypes: [],
        selectedTypeResidence: null
    }),

    methods: {
        async fetchResidenceTypes() {
            await this.$store.dispatch('parameters/fetchParameters', ['PRG_TYPERESIDENCE']);
            this.residenceTypes = this.getParameter('PRG_TYPERESIDENCE');
        }
    },

    created() {
        this.fetchResidenceTypes();
        this.selectedTypeResidence = this.value;
    }
};
</script>